import React from 'react';

import EditForm from './EditForm';
import FormLoader from '../shared/forms/FormLoader';
import PropTypes from 'prop-types';

const ServiceCallEditor = ({
    cancelEdit,
    customerId,
    editId,
    fetchData,
    scheduleOverride
}) => {
    const getUrl = `/api/servicecalls/edit/${editId}?customerId=${customerId}`;
    const postUrl = `/api/servicecalls/edit`;

    const schedule = scheduleOverride || ((editView) => window.location =
        `/calendar/scheduleServiceCall?serviceCallId=${editView.item.id}`);

    return (
        <FormLoader
            cancelEdit={cancelEdit}
            fetchData={fetchData}
            getUrl={getUrl}
            loadForm={editId !== undefined}
            postUrl={postUrl}
        >
            <EditForm cancelEdit={cancelEdit} schedule={schedule} />
        </FormLoader>
    );
}

ServiceCallEditor.propTypes = {
    cancelEdit: PropTypes.func,
    customerId: PropTypes.number,
    editId: PropTypes.number,
    fetchData: PropTypes.func
};

export default ServiceCallEditor;